import { RootState } from '../redux/index';

export const selectComplianceCentralCounters = (state: RootState) => state.complianceCentral.counters;

export const selectComplianceCentralReportsInfo = (state: RootState) => state.complianceCentral.reportsInfo;

export const selectComplianceCentralMasterFileReportsInfo = (state: RootState) =>
  state.complianceCentral.masterFileReportsInfo;
